module.exports = __webpack_public_path__ + "media/images/linkedin-1f6c94731b440c797181c5ffc411d0d3.png";